import { AppsPermissions, inventoryModule } from '../DashboardModule/modulepermissions';

export const defaultCookPermission = [
  {
    id: 429,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: null,
    featureId: null,
    key: 'mom-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 430,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 1,
    featureId: null,
    key: 'my-restaurant-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 431,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: null,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 432,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: null,
    key: 'timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 433,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: null,
    key: 'employee-availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 434,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: null,
    key: 'employee-time-off-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 435,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 6,
    featureId: null,
    key: 'employee-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 436,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: null,
    key: 'shift-scheduler-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 437,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: null,
    key: 'shift-pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 438,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: null,
    key: 'task-manager-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 439,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 37,
    featureId: null,
    key: 'docvault-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 440,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: null,
    key: 'dashboard-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 441,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: null,
    key: 'lost-&-found-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 442,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: null,
    key: 'pay-management-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 443,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 444,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 1,
    featureId: 5,
    key: 'recurring-payment-method-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 445,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 446,
    roleId: 7,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 447,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 448,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 449,
    roleId: 7,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 2,
    featureId: 110,
    key: 'my-account-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 450,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 3,
    featureId: 12,
    key: 'view-own-timecards-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 451,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 3,
    featureId: 12,
    key: 'view-own-timecards-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 452,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 453,
    roleId: 7,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 454,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 455,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 456,
    roleId: 7,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 4,
    featureId: 15,
    key: 'availability-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 457,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 458,
    roleId: 7,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 459,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 460,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 461,
    roleId: 7,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 5,
    featureId: 16,
    key: 'time-off-request-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 462,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 463,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 20,
    key: 'personal-information-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 464,
    roleId: 7,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 465,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 466,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 467,
    roleId: 7,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 21,
    key: 'assigned-roles-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 468,
    roleId: 7,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 469,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 470,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 471,
    roleId: 7,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 6,
    featureId: 22,
    key: 'location-level-access-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 472,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 473,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 6,
    featureId: 23,
    key: 'documents-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 474,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 31,
    key: 'own-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 475,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 33,
    key: 'release-other-employees-shift-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 476,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 34,
    key: 'release-shifts-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 477,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 35,
    key: 'assign-to-another-employee-button-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 478,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 11,
    featureId: 118,
    key: 'release-manager-approval-required-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 479,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 36,
    key: 'pool-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 480,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 12,
    featureId: 37,
    key: 'pool-view-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 481,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 86,
    key: 'can-be-assigned-a-task-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 482,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 483,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 35,
    featureId: 122,
    key: 'tasks-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 484,
    roleId: 7,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 485,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 486,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 487,
    roleId: 7,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 89,
    key: 'custom-category-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 488,
    roleId: 7,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 489,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 490,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 491,
    roleId: 7,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 123,
    key: 'files-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 492,
    roleId: 7,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 493,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 494,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 495,
    roleId: 7,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 37,
    featureId: 124,
    key: 'folders-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 496,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 38,
    featureId: 11,
    key: 'your-week-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 497,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 38,
    featureId: 11,
    key: 'your-week-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 498,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 499,
    roleId: 7,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 500,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 501,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 502,
    roleId: 7,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 125,
    key: 'lost-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 503,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 504,
    roleId: 7,
    userId: null,
    permissionId: 1,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 505,
    roleId: 7,
    userId: null,
    permissionId: 4,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 506,
    roleId: 7,
    userId: null,
    permissionId: 2,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 507,
    roleId: 7,
    userId: null,
    permissionId: 3,
    appId: 1,
    moduleId: 39,
    featureId: 126,
    key: 'found-items-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 508,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 39,
    featureId: 127,
    key: 'mark-as-retrieved-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 509,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 1,
    moduleId: 42,
    featureId: 132,
    key: 'view-own-paystubs-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1351,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: null,
    featureId: null,
    key: 'pos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1352,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: null,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1353,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 14,
    featureId: 133,
    key: 'clock-in-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1604,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: null,
    featureId: null,
    key: 'mpos-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'App',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1605,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: null,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Module',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 1606,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 3,
    moduleId: 22,
    featureId: 77,
    key: 'login-visible',
    isGranted: true,
    isApprovalNeeded: true,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
  {
    id: 3467,
    roleId: 7,
    userId: null,
    permissionId: 5,
    appId: 2,
    moduleId: 20,
    featureId: 70,
    key: 'employee-attendance-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: 'Feature',
    type: 'Role',
    status: 'Active',
    createdBy: 'System',
  },
];

export const inventoryPermissions = [
  AppsPermissions['web-dash-visible'],
  inventoryModule['inventory-visible'],
  inventoryModule['ingredients-visible'],
  inventoryModule['ingredients-read'],
  inventoryModule['ingredients-edit'],
  inventoryModule['ingredients-delete'],
  inventoryModule['ingredients-create'],
  inventoryModule['orders-visible'],
  inventoryModule['orders-read'],
  inventoryModule['orders-edit'],
  inventoryModule['orders-create'],
  inventoryModule['orders-delete'],
  inventoryModule['recipes-visible'],
  inventoryModule['recipes-read'],
  inventoryModule['recipes-edit'],
  inventoryModule['recipes-delete'],
  inventoryModule['recipes-create'],
  inventoryModule['invoices-visible'],
  inventoryModule['invoices-read'],
  inventoryModule['invoices-edit'],
  inventoryModule['invoices-create'],
  inventoryModule['invoices-delete'],
  inventoryModule['storage-areas-visible'],
  inventoryModule['storage-areas-read'],
  inventoryModule['storage-areas-edit'],
  inventoryModule['storage-areas-create'],
  inventoryModule['storage-areas-delete'],
  inventoryModule['vendors-visible'],
  inventoryModule['vendors-read'],
  inventoryModule['vendors-edit'],
  inventoryModule['vendors-create'],
  inventoryModule['vendors-delete'],
  inventoryModule['non-ingredients-visible'],
  inventoryModule['non-ingredients-read'],
  inventoryModule['non-ingredients-edit'],
  inventoryModule['non-ingredients-create'],
  inventoryModule['non-ingredients-delete'],
];
